import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENABLE_BLACK_HISTORY_LOGO = createFcmDetails('enable_black_history_logo', {
	// owner: '',
	context: 'Page header',
	description: 'Replace the default logo with a "black history month" logo. Usually only enabled for US.',
	import: false,
});
